import React from 'react'
import EventMangementForm from '../../features/eventManagement/EventMangementForm'

const EventManagement = () => {
    return (
        <EventMangementForm />
    )
}

export default EventManagement